/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as Utils from '@Cyclope-Utils/index';
import {ExtractorPdfIncidentActionFail, ExtractorPdfIncidentActionInProgress, ExtractorPdfIncidentActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';

/**
 * @function ExtractorPdfIncidentActionCreator
 * @param { any }  incidentParams
 * @return {Promise<any>}  Promise
 */
export function ExtractorPdfIncidentActionCreator(incidentParams: any): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ExtractorPdfIncidentActionInProgress());

        await Utils.fetchExtractPdf(incidentParams)
        .then((response: any)=> {
      if (response.ok) {
        /**
         * @constant
         * @name contentHeader
         * @type string
         */
        const contentHeader: string = response.headers.get('content-type');
        { /* Comparer les valeurs */
        }
        if (contentHeader && contentHeader !== null &&
            contentHeader.indexOf('application/json') !== -1) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat en JSON  */
            }
            response.blob().then((data: any) => {
              dispatch(
                  ExtractorPdfIncidentActionSuccess(data + `${Math.random()}`));
              const file = new Blob([data], {type: 'application/pdf'});
              const urlz = window.URL.createObjectURL(file);
              const a = document.createElement('a');
              a.href = urlz;
              a.download = 'incident-' + incidentParams + '.pdf';

              document.body.appendChild(a);
              a.click();
              a.remove();
            });  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.json().then(
                (text: any) => dispatch(ExtractorPdfIncidentActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
        if (contentHeader === null || contentHeader === undefined) {
          if (response.status === 200) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.blob().then((data: any) => {
              dispatch(
                  ExtractorPdfIncidentActionSuccess(data + `${Math.random()}`));
              const file = new Blob([data], {type: 'application/pdf'});
              const urlz = window.URL.createObjectURL(file);
              const a = document.createElement('a');
              a.href = urlz;
              a.download = 'incident-' + incidentParams + '.pdf';

              document.body.appendChild(a);
              a.click();
              a.remove();
            })  // État du state : resultat final
          } else if (response.status === 203) {
            { /** Renvoie une promise qui retourne le résultat undefined */
            }
            response.text().then(
                (text: any) => dispatch(ExtractorPdfIncidentActionSuccess(
                    [])))  // État du state : resultat final
          }
        }
      } else {
        throw ({
          message: response.statusText,
          status: response.status,
          url: response.url,
          headers: response.headers
        });
      }}).catch( (error: any) => {
                dispatch(ExtractorPdfIncidentActionFail(error.status + ' -- ' + Math.random())) /* { // État du state : échec  }*/
                Utils.fetchLogs(error.url,error.message,error.status,error.headers)
            })
  }


  /*
  try {

      await Utils.fetchExtractPdf(incidentParams)
          .then(res => {
              if (res.ok !== true) {
                  throw Error(res.statusText);
                  dispatch(ExtractorPdfIncidentActionFail(res.statusText));
              }

              return res.blob()
          })
          .then(response => {
              dispatch(ExtractorPdfIncidentActionSuccess('download pdf
succees...' + `${Math.random()}`)); const file = new Blob([response], {type:
'application/pdf'}); const urlz = window.URL.createObjectURL(file); const a =
document.createElement('a'); a.href = urlz; a.download =
'incident-'+incidentParams+'.pdf';

              document.body.appendChild(a);
              a.click();
              a.remove();
          })
  } catch (error) {
      dispatch(ExtractorPdfIncidentActionFail(error));
  }





}*/
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/extractpdfincident/index.ts